/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Pagination } from "../../commons/types/Pagination";
import { File_ } from "./File_";
export const ListFilesResponse = core.serialization.object({
    pagination: Pagination.optional(),
    data: core.serialization.list(File_),
});
